import React, { useEffect, useState } from "react";
import {
  ActivityHistoryPoint,
  EntitlementsApiError,
  getIdentityHistory,
} from "../../../api/entitlementsAdminApi";

interface Props {
  identityId?: string;
}

/** Monthly call counts for one identity, loaded when the identity changes. */
const UserActivitySection: React.FC<Props> = ({ identityId }) => {
  const [points, setPoints] = useState<ActivityHistoryPoint[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setPoints(null);
    setError(null);
    if (!identityId) return;
    let cancelled = false;
    getIdentityHistory(identityId, "month")
      .then((data) => {
        if (!cancelled) setPoints(data ?? []);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(
          err instanceof EntitlementsApiError ? err.detail : "Failed to load activity.",
        );
      });
    return () => {
      cancelled = true;
    };
  }, [identityId]);

  if (!identityId) return null;

  return (
    <div className="mt-10">
      <label className="block text-gray-700 mb-2 font-medium">Activity</label>
      {error ? (
        <p className="text-red-600 text-sm">{error}</p>
      ) : points === null ? (
        <p className="text-gray-500 text-sm">Loading...</p>
      ) : points.length === 0 ? (
        <p className="text-gray-500 italic">No recorded activity.</p>
      ) : (
        <table className="w-full text-sm text-left">
          <thead>
            <tr className="text-gray-600 border-b">
              <th className="py-1 pr-4">Month</th>
              <th className="py-1">Calls</th>
            </tr>
          </thead>
          <tbody>
            {points.map((p) => (
              <tr key={p.bucket} className="border-b border-gray-100">
                <td className="py-1 pr-4">{p.bucket}</td>
                <td className="py-1">{p.call_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UserActivitySection;
